module.exports = __webpack_public_path__ + "static/media/thumbnail.2a6ffe24.jpg";